import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MenuItemsContentComponent } from "./features/menu-items-content/menu-items-content.component";
const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "",
  },
  {
    path: ":companyId/:menuItemType/:menuItemId",
    component: MenuItemsContentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
